<template v-slot:item="data">
    <q-card
        @click="$emit('select')"
        class="full-width q-pa-md q-mb-sm"
        :class="{
            'defect-card--selectable': isSelectable,
            'defect-card--selected': isSelected
        }"
        bordered
        flat
    >
        <q-card-section horizontal full-width class="justify-between">
            <div class="flex column justify-center ellipsis">
                <!-- Fields -->
                <div>
                    <div class="text-h6 q-mb-xs">
                        {{ name }}
                    </div>
                    <div
                        v-if="description.length > 0"
                        class="defect-card__description"
                    >
                        {{ description }}
                    </div>
                    <div v-else class="q-mb-lg"></div>
                    <div class="defect-card__code">
                        <q-icon
                            name="fa-solid fa-barcode-read"
                            size="xs"
                            class="q-mr-sm"
                        />
                        {{ code }}
                    </div>
                </div>
            </div>

            <!-- Actions -->
            <q-card-section
                class="col-auto justify-around q-pl-xs q-pr-none card-actions-border"
                vertical
            >
                <q-card-actions
                    v-if="isSelectable"
                    class="col-auto justify-around q-pl-xs q-pr-none"
                >
                    <q-icon
                        v-if="isSelected"
                        name="fas fa-check-square"
                        color="primary"
                        size="md"
                    />
                    <q-icon
                        v-else
                        name="fal fa-square"
                        color="primary"
                        size="md"
                    />
                </q-card-actions>
                <q-card-actions
                    v-else
                    class="col-auto justify-around q-pl-xs q-pr-none"
                    :vertical="$q.screen.lt.sm"
                >
                    <q-btn
                        @click="$emit('edit')"
                        class="q-pa-sm card__button--edit"
                        :disable="$userCannot('edit', 'quality_defects')"
                        color="accent"
                        icon="fas fa-edit"
                        size="md"
                        flat
                    />
                    <q-btn
                        @click="$emit('delete')"
                        :disable="$userCannot('delete', 'quality_defects')"
                        :color="
                            $userCannot('delete', 'quality_defects')
                                ? 'grey'
                                : 'red-6'
                        "
                        class="q-pa-sm card__button--delete"
                        icon="fas fa-trash"
                        size="md"
                        flat
                    />
                </q-card-actions>
            </q-card-section>
        </q-card-section>
    </q-card>
</template>

<script>
export default {
    name: 'DefectCard',
    emits: ['select', 'edit', 'delete'],
    props: {
        /**
         * Quality defect fields.
         */
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        code: {
            type: String,
            required: true
        },
        /**
         * Card options.
         */
        // is the card currently selected?
        isSelected: {
            type: Boolean,
            required: false
        },
        // should cards be selectable?
        isSelectable: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>

<style lang="scss">
.defect-card__code {
    color: $grey-7;
    font-weight: 500;
    margin-top: 8px;
}

.card-actions-border {
    border-left: 1px solid $light-grey;
    margin-left: 8px;
}

.defect-card__description {
    color: $grey-7;
}

.defect-card--selectable {
    cursor: pointer;
}

.defect-card--selected {
    background-color: $grey-3;
}
</style>
